import { FilePdf } from "@phosphor-icons/react"
import { Circle } from "@phosphor-icons/react/dist/ssr"
import { OverflowMenu, Tag } from "@vesatogo/grass-core"
import { inr } from "@vesatogo/utils"
import classNames from "classnames"
import dayjs from "dayjs"

export interface AgreementStatusCardProps {
  attachments: any[]
  status: string
  statusColor?: string
  onDownload?: () => void
  onAttachmentClick?: (item: any) => void
  className?: string
  name?: string
  agreement?: any
}

export const AgreementStatusCard = ({
  attachments,
  status,
  statusColor = "text-green",
  onDownload,
  onAttachmentClick,
  className,
  name,
  agreement,
}: AgreementStatusCardProps) => {
  return (
    <div
      className={classNames(
        " flex flex-col gap-2 p-4 border border-gray-300 border-dashed rounded-lg",
        className
      )}
    >
      <div className="flex justify-between items-center ">
        <div className="flex gap-2 items-center">
          <div className="flex items-center">
            <FilePdf size={18} />
          </div>
          <span className="flex gap-1">
            {attachments?.length > 0 ? (
              <OverflowMenu
                items={attachments || []}
                getTitle={item => item?.media?.url?.slice(0, 21)}
                ellipsize
                ellipsizedTextLength={20}
                onClick={item => {
                  if (onAttachmentClick) {
                    onAttachmentClick(item)
                  } else {
                    window.open(item?.media?.url, "_blank")
                  }
                }}
                visibleItems={1}
              />
            ) : (
              <Tag variant="outline" intent="info" className="!rounded-xl">
                No Attachments
              </Tag>
            )}
          </span>
        </div>

        <div className="flex gap-2 items-center">
          <p className={classNames("!text-sm font-700", statusColor)}>
            {status}
          </p>
        </div>
      </div>
      <div className="text-xs ml-8 text-gray-600 flex items-center gap-1">
        <span>{dayjs(agreement?.start_date).format("DD MMM, YYYY")}</span>
        {` to `}
        <span>{dayjs(agreement?.end_date).format("DD MMM, YYYY")}</span>
        <Circle size={4} weight="fill" />
        <span>
          {(() => {
            const months = dayjs(agreement?.end_date).diff(
              dayjs(agreement?.start_date),
              "month"
            )
            if (months >= 1) {
              return `${months} month${months > 1 ? "s" : ""}`
            }
            const days = dayjs(agreement?.end_date).diff(
              dayjs(agreement?.start_date),
              "day"
            )
            return `${days} day${days > 1 ? "s" : ""}`
          })()}
        </span>
        <Circle size={4} weight="fill" />
        <span>{inr(agreement?.lease_amount)}</span>
        <Circle size={4} weight="fill" />
        <span>id: {agreement?.id}</span>
      </div>
    </div>
  )
}
